import { GameState } from '../types';
import { INTRUDER_SPAWN_INTERVAL, INTRUDER_COIN_DROP, INTRUDER_SIZE } from '../constants';
import { spawnIntruder, updateIntruders } from '../entities/intruder';
import { updateProjectiles } from '../entities/projectile';
import { spawnBoopParticles, spawnCoinParticles } from '../particles';
import { playBoopSound } from '../audio';
import { dist } from '../collision';

export function updateCombat(state: GameState, dt: number): void {
  // Spawn timer
  const spawnInterval = INTRUDER_SPAWN_INTERVAL / state.baseLevel;
  state.intruderSpawnTimer -= dt;
  if (state.intruderSpawnTimer <= 0) {
    spawnIntruder(state);
    state.intruderSpawnTimer = spawnInterval;
  }

  // Update intruders
  updateIntruders(state, dt);

  // Update projectiles
  updateProjectiles(state, dt);

  // Check projectile-intruder collisions
  for (const proj of state.projectiles) {
    for (const intruder of state.intruders) {
      if (!intruder.alive || intruder.boopTimer > 0) continue;
      const d = dist(proj.x, proj.y, intruder.x, intruder.y);
      if (d < INTRUDER_SIZE) {
        // Boop!
        const dx = intruder.x - proj.x;
        const dy = intruder.y - proj.y;
        const nd = Math.sqrt(dx * dx + dy * dy) || 1;
        intruder.boopTimer = 0.4;
        intruder.boopDx = (dx / nd) * 200;
        intruder.boopDy = (dy / nd) * 200;

        // Effects
        spawnBoopParticles(intruder.x, intruder.y);
        playBoopSound();

        // Drop coins
        state.player.coins += INTRUDER_COIN_DROP;
        spawnCoinParticles(intruder.x, intruder.y - 10);

        // Remove projectile
        proj.lifetime = 0;
        break;
      }
    }
  }
}
